const blue = '#6ABEC7';
const blueDarker = '#5CABB3';
const blueLighter = '#82CFD7';
const blueDarkest = '#4F686B';
const blueLightest = '#F6FCFD';
const blueBright = '#d7f5f9';
const grayDark = '#9A948E';
const green = '#87BA58';
const orange = '#E38435';
const white = '#fff';
const whiteBlue = '#E6FDFF';

const mainTextColor = blueDarkest;

export default {
  blue,
  blueDarkest,
  blueDarker,
  blueLighter,
  blueLightest,
  blueBright,
  white,
  whiteBlue,
  grayDark,
  green,
  orange,

  // Header
  logoBg: blueDarker,
  headerBg: blueLighter,
  headerSearchBg: blue,
  searchText: whiteBlue,
  searchResultText: mainTextColor,
  searchHover: blueBright,

  // Sidebar
  sidebarBg: blueLightest,
  sidebarText: blueDarker,

  // Content
  contentBg: blueLightest,
  contentText: mainTextColor,
  tabBg: white,
  inputText: blueDarkest,
};



// WEBPACK FOOTER //
// ./src/constants/Colors.js